import { render, staticRenderFns } from "./CommuneGroup.vue?vue&type=template&id=19845d8b&scoped=true"
import script from "./CommuneGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommuneGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19845d8b",
  null
  
)

export default component.exports